// 声明全局变量
declare global {
  interface Window {
    __APP_VERSION__: string
  }
}

// 处理模块加载错误
const handleModuleError = (error: Error | string) => {
  const errorMessage = typeof error === 'string' ? error : error.message
  // 检查是否是模块加载错误
  if (
    errorMessage &&
    typeof errorMessage === 'string' &&
    (errorMessage.includes('Importing a module script failed') ||
      errorMessage.includes('Failed to fetch dynamically imported module'))
  ) {
    console.log('Module load error detected, clearing cache and reloading...')
    clearCacheAndReload()
  }
}

// 清除缓存并重新加载
const clearCacheAndReload = async () => {
  // 清除所有缓存
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)))
    } catch (error) {
      console.error('Failed to clear caches:', error)
    }
  }

  // 强制刷新页面，使用 replace 而不是 reload 来避免历史记录问题
  window.location.replace(window.location.href)
}

// 版本检查工具
export const checkVersion = async () => {
  try {
    // 获取当前版本，添加时间戳防止缓存
    const response = await fetch(`/version.json?t=${Date.now()}`, {
      headers: {
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
      },
    })

    if (!response.ok) {
      throw new Error('Failed to fetch version.json')
    }

    const currentVersion = await response.json()
    const appVersion = window.__APP_VERSION__

    // 如果版本不匹配，清除缓存并刷新
    if (currentVersion.version !== appVersion) {
      console.log('Version mismatch detected:', {
        current: currentVersion.version,
        app: appVersion,
        buildTime: currentVersion.buildTime,
        environment: currentVersion.environment,
      })

      await clearCacheAndReload()
    }
  } catch (error) {
    console.error('Version check failed:', error)
    // 如果是模块加载错误，也清除缓存并重新加载
    if (error instanceof Error) {
      handleModuleError(error)
    }
  }
}

// 初始化版本检查
export const initVersionCheck = () => {
  // 监听全局错误
  window.addEventListener('error', ((event: ErrorEvent) => {
    handleModuleError(event.error || event.message)
  }) as EventListener)

  // 监听未处理的 Promise 错误
  window.addEventListener('unhandledrejection', ((event: PromiseRejectionEvent) => {
    handleModuleError(event.reason)
  }) as EventListener)

  // 每小时检查一次版本
  const checkInterval = setInterval(checkVersion, 60 * 60 * 1000)

  // 页面加载时检查一次
  checkVersion()

  // 在页面可见性改变时检查版本
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkVersion()
    }
  })

  // 在页面获得焦点时检查版本
  window.addEventListener('focus', checkVersion)

  // 清理函数
  return () => {
    clearInterval(checkInterval)
    document.removeEventListener('visibilitychange', checkVersion)
    window.removeEventListener('focus', checkVersion)
    window.removeEventListener('error', ((event: ErrorEvent) => {
      handleModuleError(event.error || event.message)
    }) as EventListener)
    window.removeEventListener('unhandledrejection', ((event: PromiseRejectionEvent) => {
      handleModuleError(event.reason)
    }) as EventListener)
  }
}
